import React, { Component } from "react";
import { connect } from "react-redux";
import classes from "./Login.css";
import * as actions from "../../../store/actions/auth";
import TwoFactorModal from "../TwoFactorModal/TwoFactorModal";

class Authentication extends Component {

  state = {
    username: null,
    password: null
  }


  // MARK: - Handling

  inputChangeHandler = (newValue, field) => {

    let newState = {...this.state};
    newState[field] = newValue;
    this.setState(newState);
  }

  initiateLogin = (event) => {

    event.preventDefault()
    
    // Prevent multiple submissions
    if (this.props.loading) return;
    
    this.props.authenticate(this.state.email, this.state.password);
  }


  render() {
    let error = (
      <div className={classes.errorContainer}>
        <p>{this.props.authError}</p>
      </div>
    )

    // Only show login error when 2FA modal is not open
    const showError = !this.props.requiresTwoFactor && this.props.authError != null;

    return (
      <div className={classes.pageContainer}>
        {/* 2FA Modal */}
        <TwoFactorModal />

        {/* Login Form */}
        <div className={classes.authContainer}>
          <h1 className={classes.signInLabel}>Sign in</h1>
          <form>
            <input
              type="email"
              placeholder="Username"
              autoComplete="username"
              className={classes.emailField}
              disabled={this.props.loading}
              onChange={(event) => this.inputChangeHandler(event.target.value, "email")}/>
            <input
              type="password"
              placeholder="Password"
              autoComplete="current-password"
              className={classes.passwordField}
              disabled={this.props.loading}
              onChange={(event) => this.inputChangeHandler(event.target.value, "password")}/>
            <button 
              onClick={(event) => this.initiateLogin(event)} 
              className={classes.signInButton}
              disabled={this.props.loading}>
              {this.props.loading ? <span className={classes.spinner}></span> : "Sign in"}
            </button>
          </form>
        </div>
        {showError ? error : null}
      </div>
    );
  }
}


// MARK: - Redux

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    loading: state.auth.loading,
    requiresTwoFactor: state.auth.requiresTwoFactor
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (email, password) => dispatch(actions.authenticate(email, password))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Authentication);
